<template>
  <div class="com">
    <button class="close" @click="closeModal">
      <CloseIcone></CloseIcone>
    </button>
    <div class="title">
      <div class="title-txt">
         <div class="button-container">
            KIT LIST
          <span class="title-txt-span" v-if="user !== null"
            >{{ user.testkits.length }} Total</span
          >
          <button class="print-btn" @click="back">Back</button>
        </div>
      </div>
      
      <div class="title-date">
        <span class="title-date-span">Sort by:</span>
        <button class="btn btn-date">
          Date of Submission
          <!--<img class="title-date-img" src="../../images/dashboard/down-grey.svg">-->
        </button>
      </div>
    </div>
    <div class="search-input-wrap" v-if="user !== null">
      <img
        src="../../images/dashboard/search.png"
        alt="#"
        class="search-input-img"
      />
      <input
        type="text"
        class="search-input"
        placeholder="Search..."
        v-model="searchModel"
        @keyup.enter="sendsearchReq(user.id)"
      />
    </div>
    <div class="wrap" v-if="user !== null">
      <div class="date-wrap" v-for="item in testKits">
        <div class="col">
          <div class="item">
            <div class="item-title">
              Kit ID
            </div>
            <div class="item-val kit" @click="showThisKit(item.id)">
              {{ convertKitId(item.kit_id) }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Status
            </div>
            <div class="status-wrap">
              <div class="item-val">
                <span v-if="item.status === 'shipped'">
                  <span class="circle blue"></span>Shipped
                </span>
                <span v-if="item.status === 'activated'">
                  <span class="circle"></span>Activated
                </span>
                <span v-if="item.status === 'lab_received'">
                  <span class="circle orange"></span>Lab Received
                </span>
                <span v-if="item.status === 'lab_awaiting'">
                  <span class="circle orange"></span>Submitted
                </span>
                <span v-if="item.status === 'on_hold'">
                  <span class="circle" style="background-color: #E87A01;"></span
                  >On Hold
                </span>
                <span v-if="item.status === 'analysis_completed'">
                  <span class="circle green"></span>Analysis Complete
                </span>
                <span v-if="item.status === 'analysis_failed'">
                  <span class="circle red"></span>Analysis Failed
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="item">
            <div class="item-title">
              Date of Submission
            </div>
            <div class="item-val">
              {{ date(item.submission_at) }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Date of Activation
            </div>
            <div class="item-val">
              {{ date(item.activated_at) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";
import CloseIcone from "../../images/shared/cancel";

export default {
  name: "ModalKits",
  mixins: [parseAndConvertKitId],
  data() {
    return {
      user: null,
      kit: null,
      testKits: null,
      searchModel: null
    };
  },
  components: {
    CloseIcone
  },
  methods: {
    ...mapActions(["testKitInfo", "clearInfo", "searchIntoUser"]),
    sendsearchReq(id) {
      this.searchIntoUser({ search: this.searchModel, id }).then(res => {
        this.testKits = res.data.data.testkits.data;
      });
    },
    date(localDate) {
      if (localDate) {
        let date = localDate;
        const possition = localDate.indexOf("T");
        if (possition > -1) {
          date = localDate.substring(0, possition);
        }
        return moment(date).format("MMMM Do, YYYY");
      }
    },
    closeModal() {
      this.clearInfo();
      //this.$emit("closeModal", false);
    },
    showThisKit(id) {
      this.testKitInfo(id).then(res => {
        this.$emit("changeDescModal", false);
      });
    },
    back(){
      this.$emit("changeDescModal", false);
    }
  },
  mounted() {
    this.user = this.$store.getters.getAdminUserInfo;
    if (this.user !== null) {
      this.testKits = this.user.testkits;
    }
  }
};
</script>

<style scoped>
.wrap {
  height: 530px;
  overflow: auto;
}
.col {
  width: 50%;
}
.item {
  margin: 0 0 30px 0;
  position: relative;
}
.item-title {
  margin: 0 0 20px 0;
  color: #000;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.item-val {
  color: #000;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  position: relative;
}
.date-wrap {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
  padding: 20px 0 0 0;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.com {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 25px 30px;
  position: relative;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 0 0;
  color: #005eb8;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.title-txt-span {
  color: #b3b3b3;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.title-date-span {
  color: #b3b3b3;
  padding: 0 5px 0 0;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.btn {
  outline: none;
  border: 1px solid transparent;
  padding: 0;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 160px;
  width: 100%;
  color: #000;
  line-height: 1.3;
  font-size: 14px;
  font-family: TTNormsRegular, sans-serif;
  cursor: pointer;
}
.title-date {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 230px;
  width: 100%;
}
.title-date-img {
  width: 16px;
  height: 17px;
}
.circle.green {
  background-color: green;
}
.circle.red {
  background-color: red;
}
.circle.orange {
  background-color: orange;
}
.circle.yellow {
  background-color: gold;
}
.circle.blue {
  background-color: #03409a;
}
.circle {
  display: inline-block;
  margin: 0 5px 0 0;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: #cccdcf;
}
.item-val.kit:hover {
  color: #005eb8;
  cursor: pointer;
}
.search-input-wrap {
  margin: 10px 0 0 0;
  position: relative;
  border-bottom: 2px solid #eee;
}
.search-input-img {
  position: absolute;
  left: 0;
  top: 0;
  width: 22px;
  height: auto;
}
.search-input {
  width: 100%;
  height: 30px;
  padding: 0 0 0 40px;
  border: none;
  background-color: #fff;
  color: #000;
  outline: none;
  font-size: 16px;
  font-family: TTNormsLight, sans-serif;
}
.search-input::placeholder {
  color: #98a4ae;
}
.print-btn {
  width: 90px;
  height: 30px;
  background-color: #1546ad;
  color: #fff;
  border-radius: 5px;
  outline: none;
  border: none;
  cursor: pointer;
  margin-left: 10px;
}
</style>
